module.exports = __webpack_public_path__ + "static/freda@small-e30256711f97a6093af12eee5b976842.jpg";